import { AppState } from "common/models/state/app-state.model";

const initialAppState: AppState = {
  showCookieConsent: false,
  theme: "dark"
};

export { initialAppState };
